import { createElement as rc } from 'react';
import { styled, MenuHeader as _MenuHeader, fromTheme, View, Icon } from 'lib_ui-primitives';
import { useTheme } from 'styled-components';

const LeftToRight = styled(View)`
    flex-direction: row;
    padding: ${fromTheme('menu', 'header', 'padding')};
    gap: ${fromTheme('menu', 'menuItem', 'iconTextGap')};
    color: ${fromTheme('menu', 'color')};
    align-items: center;
`;
export default function MenuHeader(props) {
    const { hNode: { title, textSize, textWeight, iconName } = {} } = props || {};
    const theme = useTheme();
    const color = theme.menu.color;
    return rc(
        LeftToRight,
        null,
        iconName && rc(Icon, { name: iconName, size: 'md', children: iconName, color }),
        rc(_MenuHeader, { hNode: { title, textSize, textWeight } })
    );
}
